var _mask, _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSquareField(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_853_6004",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 22,
    height: 22,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 22,
    height: 22,
    rx: 1,
    stroke: "#242424",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_853_6004)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10.3438L13.5625 19.2812L9.5 15.2188",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgSquareField;